import React, { forwardRef } from "react";
import { NavLink as RouterNavLink } from "@/compat/router";

// Bridges the react-router v5 NavLink props the sidebar still passes
// (`activeClassName`, `exact`, `innerRef`) to the v7 API:
//  - `innerRef`/ref  -> `ref`
//  - `exact`         -> `end`
//  - `activeClassName` -> appended via the `className` render function when active
// Consuming these here stops them leaking onto the DOM <a> element.
const NavLinkWrapper = forwardRef(
  ({ activeClassName = "active", exact = false, className, innerRef, ...props }, ref) => (
    <RouterNavLink
      ref={ref ?? innerRef}
      end={exact}
      className={({ isActive }) =>
        [className, isActive ? activeClassName : ""].filter(Boolean).join(" ")
      }
      {...props}
    />
  )
);

export default NavLinkWrapper;
